import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import styles from './RequestDetails.module.css'
import { _ToNormal, setDate } from "../../../../../Utils/helper";
import { DOCUMENT_PREVIEW, GET_HOLDER_SHARED_DATA } from "../../../../../Utils/constant";
import Error from "../../../../../components/OnBoard/Error";
import API from '../../../../../ApiConfig'
import Icon from "react-icons-kit";
import { androidArrowBack } from 'react-icons-kit/ionicons/androidArrowBack'
import SlideUpWrapper from "../../../../../components/Transitions/SlideUpWrapper";
import ReactPortalModal from "../../../../../components/ReactPortalModal";
import cogoToast from "cogo-toast-react-17-fix";

export default function RequestDetails() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const { request_id } = useParams();

    const [preview, setPreview] = useState(null)
    const [title, setTitle] = useState('Preview Document')
    const [pdfLoading, setPDFloading] = useState(null)
    const getPdf = (key, item, index) => {
        setTitle(key)
        setPDFloading(index)
        API.get(DOCUMENT_PREVIEW + item)
            .then(response => {
                setPDFloading(null)

                setPreview(response.data.data.pdf);
            }).catch(err => {
                setPDFloading(null);
                setPreview(null)
            })
    }

    const DocPreview = () => {
        var loading = {
            padding: "1rem",
            height: "10vh",
            width: "-webkit-fill-available",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
        if (!preview) {
            return (<div style={loading}>
                {loadingText}
            </div>)
        }
        else {
            return (
                <embed
                    key={preview}
                    id="pdf-viewer"
                    src={preview + "#toolbar=0"}
                    type="application/pdf"
                    style={{width:"1000px", height:"700px"}}
                />
            )
        }
    }

    useEffect(() => {
        // setData({
        //     "name": "Aviral",
        //     "email": "aviral.sharma@authbridge.com",
        //     "phone_number": "9911416415",
        //     "created_at": "2024-12-17T17:42:51.939355",
        //     "form_type": "document",
        //     "shared_data": {
        //         "name": "Aviral",
        //         "email": "aviral.sharma@authbridge.com",
        //         "Experience Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "New Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "Old Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "Another Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "Experience Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
        //     }
        // })
        setLoading(true)
        API.get(GET_HOLDER_SHARED_DATA + request_id)
            .then(res => {
                if (res.data.status === 200) {
                    setData(res.data.data)
                }
            })
            .catch(err => {
                cogoToast.error(err.response.data.detail)
                setData(1)
            })
            .finally(() => setLoading(false))
    }, [])


    if (data == 1) {
        return <Error Message="Invalid Request ID" />
    }
    return (
        <div style={{ width: "100%" }}>
            <SlideUpWrapper direction='slide-left'>
                <div>
                    <h2 className={styles.header}>
                        <Icon icon={androidArrowBack} size={'1.2rem'} onClick={() => navigate('../forms/myRequests')} style={{ cursor: 'pointer' }} />
                        {loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data.name}
                    </h2>
                    <div className={styles.section}>
                        <div className={styles.mainContainer}>
                            <div className={styles.tableHeader}>
                                <span className="heading">{loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data.name}</span>
                                <div className={styles.basicDetails}>
                                    <div>
                                        <span className="heading">Phone</span>
                                        <span>{loading ? <div className="shimmer" /> : data.phone_number}</span>
                                    </div>
                                    <div>
                                        <span className="heading">Email</span>
                                        <span>{loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data.email}</span>
                                    </div>
                                    <div>
                                        <span className="heading">Searched on</span>
                                        <span>{loading ? <div className="shimmer" /> : setDate(data.created_at)}</span>
                                    </div>
                                </div>
                            </div>
                            <table style={{ width: '100%', textAlign: 'left' }}>
                                <tbody>
                                    {data.shared_data && Object.entries(data.shared_data).map(([key, value], index) => (
                                        <tr key={index} className="credentials-header1" style={{ alignItems: 'center' }}>
                                            <td className="credentials-td" style={{ justifyContent: 'flex-start', maxWidth: '10rem' }}>{key}</td>
                                            <td className="credentials-td" style={{ justifyContent: 'flex-start' }}>{value == null ? (
    "Document Link Expired"        // or return empty string, or "N/A", anything you want
) : Number.isInteger(value) && data.form_type === "Document" ? (
    <button
        className="btn btn-secondary"
        onClick={e => {
            if (!pdfLoading) getPdf(key, value, index);
        }}
        style={{ display: "flex", gap: "0.3rem", textDecoration: "none" }}
    >
        <img
            className={styles.downloadOutlineIcon}
            alt=""
            src="/downloadoutline.svg"
        />
        {pdfLoading === index ? "Loading..." : "Download PDF"}
    </button>
) : value?.includes("https") ? (
    <img src={value} width="200px" height="200px" />
) : (
    value
)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <ReactPortalModal title={title} isOpen={preview} onClose={e => setPreview(null)}>
                        <DocPreview />
                    </ReactPortalModal>
                </div>
            </SlideUpWrapper>
        </div>
    );
};
